import * as React from "react";
import { css } from "@emotion/core";
import {
  useVirtualizer,
  type Virtualizer,
  type VirtualItem,
} from "@tanstack/react-virtual";

export const STRIPED_ROW_BACKGROUND = "rgba(95, 107, 124, 0.15)";

const ROW_ESTIMATED_HEIGHT = 41;

export function useAdminTableVirtualizer<T extends { id: number }>(
  items: T[],
  scrollRef: React.RefObject<HTMLDivElement>
) {
  return useVirtualizer({
    count: items.length,
    getScrollElement: () => scrollRef.current,
    estimateSize: () => ROW_ESTIMATED_HEIGHT,
    getItemKey: (index) => items[index].id,
    overscan: 10,
  });
}

export function VirtualizedTableBody(props: {
  virtualizer: Virtualizer<HTMLDivElement, Element>;
  colSpan: number;
  renderRow: (virtualRow: VirtualItem) => React.ReactNode;
}) {
  const { virtualizer, colSpan, renderRow } = props;
  const virtualItems = virtualizer.getVirtualItems();
  const paddingTop = virtualItems.length > 0 ? virtualItems[0].start : 0;
  const paddingBottom =
    virtualItems.length > 0
      ? virtualizer.getTotalSize() -
        virtualItems[virtualItems.length - 1].end
      : 0;

  return (
    <tbody>
      {paddingTop > 0 && (
        <tr aria-hidden="true">
          <td
            colSpan={colSpan}
            css={css`
              height: ${paddingTop}px;
              padding: 0 !important;
              border: none !important;
              box-shadow: none !important;
            `}
          />
        </tr>
      )}
      {virtualItems.map(renderRow)}
      {paddingBottom > 0 && (
        <tr aria-hidden="true">
          <td
            colSpan={colSpan}
            css={css`
              height: ${paddingBottom}px;
              padding: 0 !important;
              border: none !important;
              box-shadow: none !important;
            `}
          />
        </tr>
      )}
    </tbody>
  );
}
